import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { theme } from '../styles/design-system';
import { useNavigate } from 'react-router-dom';
import {
  MessageSquare,
  Zap,
  TrendingUp,
  Mic,
  Brain,
  User,
  LogIn
} from 'lucide-react';

const MobileNavigation = () => {
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const handleLoginClick = () => {
    navigate('/login');
  };

  const navItems = [
    {
      path: '/chat',
      icon: <MessageSquare size={20} />,
      label: 'Chat',
      active: isActive('/chat'),
    },
    {
      path: '/algo-runner',
      icon: <Zap size={20} />,
      label: 'Algo',
      active: isActive('/algo-runner'),
    },
    {
      path: '/fno-trading',
      icon: <TrendingUp size={20} />,
      label: 'F&O',
      active: isActive('/fno-trading'),
    },
    {
      path: '/voice-alerts',
      icon: <Mic size={20} />,
      label: 'Voice',
      active: isActive('/voice-alerts'),
    },
    {
      path: '/ai-dashboard',
      icon: <Brain size={20} />,
      label: 'AI',
      active: isActive('/ai-dashboard'),
    },
    {
      path: '/profile',
      icon: <User size={20} />,
      label: 'Profile',
      active: isActive('/profile'),
    },
  ];

  return (
    <>
      <nav
        style={{
          position: 'fixed',
          bottom: theme.spacing[4],
          left: theme.spacing[4],
          right: theme.spacing[4],
          backgroundColor: 'rgba(17, 24, 39, 0.85)', // Darker, glassmorphic
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '24px', // Pill shape
          padding: `${theme.spacing[2]} ${theme.spacing[2]}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: 50,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          maxWidth: '500px',
          margin: '0 auto', // Center on larger mobile screens
        }}
      >
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              padding: '8px 4px',
              borderRadius: '16px',
              textDecoration: 'none',
              color: item.active ? '#3b82f6' : '#9ca3af', // Blue for active, Gray for inactive
              flex: 1,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              transform: item.active ? 'translateY(-2px)' : 'none',
            }}
          >
            <div
              style={{
                padding: '8px',
                borderRadius: '12px',
                backgroundColor: item.active ? 'rgba(59, 130, 246, 0.15)' : 'transparent',
                transition: 'background-color 0.3s ease',
              }}
            >
              {item.icon}
            </div>
            <span
              style={{
                fontSize: '10px',
                fontWeight: item.active ? '600' : '500',
                letterSpacing: '0.02em',
                opacity: item.active ? 1 : 0.8,
              }}
            >
              {item.label}
            </span>
            {item.active && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '-4px',
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  backgroundColor: '#3b82f6',
                  boxShadow: '0 0 8px #3b82f6',
                }}
              />
            )}
          </Link>
        ))}

        {/* Mobile Login Button */}
        {!isAuthenticated && (
          <button
            onClick={handleLoginClick}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              padding: '8px 4px',
              borderRadius: '16px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#ef4444', // Red for login attention
              flex: 1,
              cursor: 'pointer',
            }}
          >
            <div
              style={{
                padding: '8px',
                borderRadius: '12px',
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
              }}
            >
              <LogIn size={20} />
            </div>
            <span style={{ fontSize: '10px', fontWeight: '600' }}>Login</span>
          </button>
        )}
      </nav>

    </>
  );
};

export default MobileNavigation;
